import React, { memo } from "react";
import TatByPersonChart from "./TatByPersonChart";
import OverdueTasksTable from "./OverdueTasksTable";

const TatOverduePanel = ({
  tatByPersonRows = [],
  overdueTaskRows = [],
  isLoading = false,
  onPersonClick,
  onOwnerClick,
  onTagClick,
}) => (
  <div className="tat-overdue-panel">
    <TatByPersonChart rows={tatByPersonRows} onPersonClick={onPersonClick} />
    <OverdueTasksTable
      rows={overdueTaskRows}
      isLoading={isLoading}
      onOwnerClick={onOwnerClick || onPersonClick}
      onTagClick={onTagClick}
    />
  </div>
);

export default memo(TatOverduePanel);
